<template>
    <div :id="parentId" class="listing-collections-carousel">
      <Swiper
        :modules="modules"
        :slides-per-view="2.5"
        :space-between="10"
        :breakpoints="breakpoints"
        @swiper="onSwiper"
        @slide-change="onSlideChange"
        :navigation="{
            nextEl: `#${parentId} .swiper-button-next-list`,
            prevEl: `#${parentId} .swiper-button-prev-list`,
        }"
      >
        <SwiperSlide v-for="(item, index) in related" :key="index">
            <ListingItem
            :item="item"
            :whistlist="is_whistlist ?? true"
            :background_item="background_item ?? 'transparent'"
            :min_max="min_max ?? false"
            :hover_zoom="hover_zoom ?? false" />
        </SwiperSlide>

        <template #container-end>
          <div class="swiper-pagination"></div>
        </template>
      </Swiper>

      <div class="box-controls" v-if="related.length > 2.5">
        <div class="box-btn">
          <div class="swiper-button swiper-button-prev-list">
            <svg
              fill="#000000"
              viewBox="0 0 24.00 24.00"
              id="right-2"
              data-name="Flat Line"
              xmlns="http://www.w3.org/2000/svg"
              class="icon flat-line"
              transform="rotate(180)"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="#CCCCCC"
                stroke-width="0.048"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <polyline
                  id="primary"
                  points="7.5 3 16.5 12 7.5 21"
                  style="
                    fill: none;
                    stroke: rgb(0, 0, 0);
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-width: 0.816;
                  "
                ></polyline>
              </g>
            </svg>
          </div>
        </div>
        <div class="box-btn">
          <div class="swiper-button swiper-button-next-list">
            <svg
              fill="#000000"
              viewBox="0 0 24.00 24.00"
              id="right-2"
              data-name="Flat Line"
              xmlns="http://www.w3.org/2000/svg"
              class="icon flat-line"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="#CCCCCC"
                stroke-width="0.048"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <polyline
                  id="primary"
                  points="7.5 3 16.5 12 7.5 21"
                  style="
                    fill: none;
                    stroke: rgb(0, 0, 0);
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-width: 0.816;
                  "
                ></polyline>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </template>

<script setup>
const props = defineProps({
    parentId: {
      type: String,
      default: null
    },
    related: {
      type: Object,
      default: null
    },
    breakpoints: {
      type: Object,
      default: null
    },
});


  import { ref } from 'vue'
  import { Swiper, SwiperSlide } from 'swiper/vue'
  import { Navigation, Autoplay } from 'swiper/modules'

  // Import Swiper styles
  import 'swiper/css'
  import 'swiper/css/navigation'
  import ListingItem from "~/components/Product/ProductItem.vue";

  // Define reactive items for the slider
  const items = ref([
    {
      title: 'Item 1',
      description: 'Description for item 1',
      image: '/path/to/image1.jpg'
    },
    {
      title: 'Item 2',
      description: 'Description for item 2',
      image: '/path/to/image2.jpg'
    },
    {
      title: 'Item 3',
      description: 'Description for item 3',
      image: '/path/to/image3.jpg'
    },
    {
      title: 'Item 4',
      description: 'Description for item 3',
      image: '/path/to/image3.jpg'
    },
    {
      title: 'Item 5',
      description: 'Description for item 3',
      image: '/path/to/image3.jpg'
    },
    {
      title: 'Item 6',
      description: 'Description for item 3',
      image: '/path/to/image3.jpg'
    },
    {
      title: 'Item 7',
      description: 'Description for item 3',
      image: '/path/to/image3.jpg'
    },
    // Add more items as needed
  ])

  // Configure Swiper modules
  const modules = [Navigation, Autoplay]

  // Swiper event handlers
  const onSwiper = (swiper) => {
    console.log('Swiper initialized', swiper)
  }

  const onSlideChange = () => {
    console.log('Slide changed')
  }
  </script>

<style lang="scss">
@import '@/assets/scss/components/sale-campaign/_carousel-production.scss';
.alt-oos-popup .swiper-wrapper {
    padding-bottom: 20px;
    padding-top: 20px;
}
</style>